module.exports = __webpack_public_path__ + "static/media/ak.67ceb89d.png";